export default class Template {
    constructor(Component) { this.Component = Component }

    /**
     * Special case when we need to show button with "price" layout
     * @return {Promise<*|string>}
     */
    async price() {
        switch (this.Component.values.type) {
            case 40: // ISet Product cannot be sold directly
                return '';
            case 0: // Custom Mix
                const product = {...this.Component.values}; // clone object
                if (product.hasAvailableOffers && product.availability) {
                    product.buttons = App.Template.parse('box-button-product', await this.Component.values);
                } else if(this.Component.isCreatorMix() || !product.availability) { // Creator Mix
                    product.buttons = App.Template.parse('box-button-soldout');
                } else {
                    product.buttons = App.Template.parse('box-button-mix', await this.Component.values);
                }
                product.price    = product.priceFormatted;
                return App.Template.parse('box-price-product', product);
            default:
                let offer = await this.Component.values.Offer;
                if (offer && offer.submittable) {
                    offer = {...offer}; // clone object
                    offer.buttons   = this.getButton(offer);
                    offer.layout    = this.Component.quickBuy ? 'standard' : 'compact';
                    offer.price     = this.Component.quickBuy ?
                        offer.priceFormatted : [__('GLOBAL.STARTING.AT'), offer.priceFormatted].join(' ');
                    return App.Template.parse('box-price-offer', offer);
                }
                return App.Template.parse('box-button-soldout');
        }
    }
    get hints() {
        return App.Template.parse('component-hints', this.Component.values);
    }
    get badge() {
        return App.Interface.Badge.renderHTML(this.Component.badge);
    }
    get buttons() {
        let buttons = this.Component.Buttons.get();
        if (buttons) {
            let content = [];
            buttons.forEach(button => {
                if (button) {
                    this.Component.Bar.belongsToBar(button)
                        ? this.Component.Bar.add(button)
                        : content.push(this.Component.Layout.getButton(button))
                    ;
                }
            });
            return content.join('');
        }
        return '';
    }
    getButton(offer = undefined) {
        if (offer && offer.availability === 1) {
            if (this.Component.quickBuy) {
                return App.Template.parse('box-button-cart-offer', {
                    id:  offer.id,
                    title:  offer.name,
                    productName: offer.productName,
                    url:    this.Component.values.url,
                });
            } else {
                return App.Template.parse('box-button-cart', {
                    id:     this.Component.values.id,
                    url:    this.Component.values.url,
                });
            }
        }

        if (this.Component.values.hasAvailableOffers) {
            return App.Template.parse('box-button-cart', {
                label:  __('GLOBAL.PLACE_IN_THE_SHOPPING_CART'),
                id:     this.Component.values.id,
                title:  this.Component.values.name,
                url:    this.Component.values.url,
            });
        } else {
            return App.Template.parse('box-button-soldout');
        }
    }
    async reference() {
        const offer = await this.Component.values.Offer;
        return App.Template.parse('box-reference', offer.referencePriceFormatted ?? '');
    }
    get score() {
        return App.Template.parse('box-score', this.Component.values.ratingMean ? this.Component.values : this.Component.score);
    }
}
